export default "__VITE_ASSET__9t8c0hLu__"